import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  const stats = [{
    value: '+500',
    label: 'Psicólogas confían'
  }, {
    value: '6 + 6',
    label: 'Tomos + Bonos'
  }, {
    value: '4.9/5 ⭐',
    label: 'calificación'
  }, {
    value: '🇦🇷 ARGENTINA',
    label: 'Todo el país'
  }];
  return <section className="py-8 border-y border-dark-border bg-dark-card/50" data-id="element-251">
      <div className="max-w-6xl mx-auto px-4" data-id="element-252">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-253">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center" data-id="element-254">
              <span className="text-2xl md:text-3xl font-black text-white mb-1" data-id="element-255">
                {stat.value}
              </span>
              <span className="text-sm text-brand font-medium uppercase tracking-wider" data-id="element-256">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}